import {Button} from '@/components/design-system';
import {ArrowRight} from '@/components/icons';
import {Link} from '@/i18n/routing';

interface Props {
  storeId: string;
  title: string;
}

export default function Nav(props: Props) {
  return (
    <div className="grid grid-cols-5 items-center pt-6">
      <div>
        <Link href={{pathname: '/bar/[barId]', params: {barId: props.storeId}}}>
          <Button type="link" theme="ghost" palette="gray">
            <div className="no-underline">
              <ArrowRight
                transform="rotate(180)"
                strokeWidth={2}
                className="text-greyscale-body"
              />
            </div>
          </Button>
        </Link>
      </div>
      <div className="col-span-3">
        <h1 className="mb-0 font-bold text-2xl text-center text-greyscale-title">
          {props.title}
        </h1>
      </div>
    </div>
  );
}
